// Photos / Design workspace switch (DRAW_PLAN G1, §10). Remembered per browser.
// M14 (V2): the Design workspace is back for ad templates, so the switch is on by default. `?design=0` in the
// address still hides it in this browser (remembered; `?design=1` shows it again).
import { create } from 'zustand';

export type Workspace = 'photos' | 'design' | 'plating';
const KEY = 'epb.workspace';
const ENABLED_KEY = 'epb.designEnabled';

function readEnabled(): boolean {
  try {
    const q = new URLSearchParams(location.search).get('design');
    if (q === '1' || q === '0') localStorage.setItem(ENABLED_KEY, q);
    return localStorage.getItem(ENABLED_KEY) !== '0';
  } catch {
    return true;
  }
}

function initial(enabled: boolean): Workspace {
  if (!enabled) {
    // Design hidden: Plating (M16) is still reachable.
    try {
      return localStorage.getItem(KEY) === 'plating' ? 'plating' : 'photos';
    } catch {
      return 'photos';
    }
  }
  try {
    const w = localStorage.getItem(KEY);
    return w === 'design' || w === 'plating' ? w : 'photos';
  } catch {
    return 'photos';
  }
}

const enabled = readEnabled();

export const useWorkspace = create<{
  ws: Workspace;
  designEnabled: boolean;
  setWs: (w: Workspace) => void;
}>((set, get) => ({
  ws: initial(enabled),
  designEnabled: enabled,
  setWs: (ws) => {
    if (ws === 'design' && !get().designEnabled) return;
    try {
      localStorage.setItem(KEY, ws);
    } catch {
      /* not remembered */
    }
    set({ ws });
  },
}));
